import { useState } from 'react';

export const useSidebar = () => {
  const [expanded, setExpanded] = useState(true);
  const [expandedProfile, setExpandedProfile] = useState(false);
  const [expandedResponsible, setExpandedResponsible] = useState(true);

  const mouseLeave = () => {
    setExpanded(true);
    setExpandedProfile(false);
    setExpandedResponsible(true);
  };

  const mouseEnter = () => setExpanded(true);

  return {
    expanded,
    setExpanded,
    expandedProfile,
    expandedResponsible,
    setExpandedProfile,
    setExpandedResponsible,
    mouseEnter,
    mouseLeave,
  };
};
